<template>
  <div
    class="search-item-widget"
    id="tour-01001-step1">
    <v-text-field
      label="商品検索"
      variant="outlined"
      append-inner-icon="mdi-magnify"
      v-model="keywordComputed"
      clearable
    ></v-text-field>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useUrlFunc } from '@/utils/url'
import { onMounted } from 'vue';
import { onBeforeUpdate } from 'vue';
import { onUpdated } from 'vue';

const url = useUrlFunc()
const route = useRoute()

// Props ------------------
interface Props {
  keyword? : string;
}

const props = withDefaults(defineProps < Props > (), {
  keyword: undefined,
})

// Emits ------------------
interface Emits {
  (e: 'update:keyword', keyword?: string): void,
}
const emits = defineEmits<Emits>();

const keyword = ref<string | undefined>(props.keyword)
const keywordComputed = computed({
  get: () => keyword.value,
  set: (value) => {
    keyword.value = value
    url.saveS(keyword.value)
    emits('update:keyword', value)
  }
})

onMounted(() => {
  // keywordComputed.value = undefined
  keywordComputed.value = url.getItemSearchQueries().s
})
onBeforeUpdate(() => {
  keywordComputed.value = url.getItemSearchQueries().s
})
</script>

<style lang="scss" scoped>
.search-item-widget {
  max-width: 200px;

  &::v-deep(.v-input__control) {
    background-color: white;
  }

  .search-item-widget--container {
    border: 2px solid rgb(var(--v-theme-black));
    border-radius: 5px;
  }

  &::v-deep(h4) {
    font-weight: 400;
    font-size: 20px;
  }

  &::v-deep(.v-list-item-title) {

    color: rgb(var(--v-theme-black));
    opacity: 1;
    font-weight: bold;
    margin-bottom: 0.4rem;
    font-size: 12px;
  }

  &::v-deep(.v-list-item-subtitle) {
    color: rgb(var(--v-theme-black));
    opacity: 1;
    line-height: 1.6;
    color: #4880D3;
    text-decoration: underline;
  }

  &:visited {
    &::v-deep(.v-list-item-subtitle) {
      color:#551A8B;
    }
}
}
</style>
